<template>
    <div class="groupFields">
        <div class="groupField">
            <div class="groupFieldTitle">
                <span class="groupFieldTitle-text">Customer requisites</span>
                <button type="button" @click="onAddRequisitesItem">
                    <svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
                    Add requisites
                </button>
            </div>
            <template v-for="(item, idx) in requisitesList">
                <div class="groupField_wrap" :key="idx">
                    <field
                        margin="0 10px 0 0"
                        width="260px"
                        label="Account name"
                        :idx="idx"
                        placeholder="Enter account name"
                        @updateInput="onInput($event, 'name')"
                        :setInputValue="requisitesList[idx].name"
                    ></field>
                    <field
                        margin="0 10px 0 0"
                        width="260px"
                        label="Account"
                        placeholder="Enter account number"
                        :idx="idx"
                        @updateInput="onInput($event, 'account')"
                        :setInputValue="requisitesList[idx].account"
                    ></field>
                    <button type="button" class="deleteItem" @click="onDeleteItem(idx)">
                        <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "CustomerRequisites",
	computed: {
		...mapGetters([ 'customersList' ]),
		getPercentType() {
			return this.customersList['percent_types'];
		},
		getTrailerRate() {
			return this.customersList['trailer_rate'];
		}
	},
	data: () => ({
		requisitesList: [],
	}),
	methods: {
		onAddRequisitesItem() {
			const value = {
				name: '',
				account: ''
			};

			this.requisitesList.push(value);
			this.getData();
		},
		onInput({ value, idx }, key) {
			this.requisitesList[idx][key] = value;
			this.getData();
		},
		onDeleteItem(idx) {
			this.requisitesList.splice(idx, 1);
			this.getData();
		},
		getData() {
			this.$emit('updateRequisitesData', this.requisitesList);
		}
	},
	mounted() {
		const { requisites = [] } = this.customersList;
		this.requisitesList = requisites;
	}
};
</script>

<style scoped lang="scss">
@import "CustomerRequisites";
</style>
